import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import Typography from '@material-ui/core/Typography';

type EditFormActionWrapperProps = {
  deleteText: string;
  didInputsChange: boolean;
  closeDialog: () => void;
  openRemoveUserDialog?: () => void;
};

const useStyles = makeStyles((theme) => ({
  actionsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  deleteUserContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  deleteUser: {
    fontSize: '17px',
    fontWeight: 600,
    lineHeight: '26px',
  },
  button: {
    marginLeft: '20px',
  },
}));

export const EditFormActionWrapper: React.FC<EditFormActionWrapperProps> = ({
  deleteText,
  closeDialog,
  didInputsChange,
  openRemoveUserDialog,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.actionsWrapper}>
      <div className={classes.deleteUserContainer}>
        <SvgIcon>
          <path d="M1.49967 15.4167C1.49967 16.425 2.32467 17.25 3.33301 17.25H10.6663C11.6747 17.25 12.4997 16.425 12.4997 15.4167V6.25C12.4997 5.24167 11.6747 4.41667 10.6663 4.41667H3.33301C2.32467 4.41667 1.49967 5.24167 1.49967 6.25V15.4167ZM4.24968 6.25H9.74968C10.2538 6.25 10.6663 6.6625 10.6663 7.16667V14.5C10.6663 15.0042 10.2538 15.4167 9.74968 15.4167H4.24968C3.74551 15.4167 3.33301 15.0042 3.33301 14.5V7.16667C3.33301 6.6625 3.74551 6.25 4.24968 6.25ZM10.208 1.66667L9.55718 1.01583C9.39218 0.850833 9.15384 0.75 8.91551 0.75H5.08384C4.84551 0.75 4.60718 0.850833 4.44218 1.01583L3.79134 1.66667H1.49967C0.995508 1.66667 0.583008 2.07917 0.583008 2.58333C0.583008 3.0875 0.995508 3.5 1.49967 3.5H12.4997C13.0038 3.5 13.4163 3.0875 13.4163 2.58333C13.4163 2.07917 13.0038 1.66667 12.4997 1.66667H10.208Z" />
        </SvgIcon>
        <Typography
          className={classes.deleteUser}
          onClick={openRemoveUserDialog}>
          {deleteText}
        </Typography>
      </div>
      <div>
        <Button
          onClick={closeDialog}
          color="primary"
          variant="outlined"
          className={classes.button}>
          Cancel
        </Button>
        <Button
          disabled={!didInputsChange}
          color="primary"
          variant="contained"
          type="submit"
          className={classes.button}>
          Save
        </Button>
      </div>
    </div>
  );
};
